import { ArrowLeftOutlined } from '@ant-design/icons';
import { Button, Divider, Input, notification, Checkbox, Skeleton } from 'antd';
import React, { useEffect, useState } from 'react'
import './singleProduct.css';
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { DIR_RTL } from "../../../constants/ThemeConstant";
import {changeQuantity, getCart, getProduct, getStoreTiming, updateDataState} from "../../../redux/actions";
import { getAttachment } from "utils/attachment";
import { addToCart, getQuantity, isItemExistsInCart, updateItemInCart } from 'utils/cart';
import { APP_PREFIX_PATH } from 'configs/AppConfig';
import SkeletonInput from 'antd/lib/skeleton/Input';
import ProductImg from './productImg';
import { isOpenByTime } from 'utils/estimated';


function SingleProduct() {
    const { theme: { direction, locale }, fetchedData: { product, storeData, timings } } = useSelector(state => state);
    const dispatch = useDispatch();
    const { id } = useParams();

    const [cartItem, setCartItem] = useState()
    const [quantity, setQuantity] = useState(1);
    const [chosenAddons, setChosenAddons] = useState({});
    const [priceWithAddons, setPriceWithAddons] = useState(0);
    const [comment, setComment] = useState('');
    const [promotions, setPromotions] = useState({});

    useEffect(() => {
        if (cartItem?.product?.id){
            dispatch(updateDataState({product:cartItem?.product}));
            setQuantity(cartItem?.quantity);
        }
    }, [cartItem]);

    useEffect(() => {
        setPriceWithAddons(
            promotions?.discountType === "AMOUNT" ?
            product?.price - promotions?.amount :
            promotions?.discountType === "PERCENTAGE" ?
            product.price - (product.price * (promotions.amount / 100)) : product.price
        );
        if (cartItem?.product?.id){
            setChosenAddons(cartItem?.attributes);
        }else{
            if (localStorage.getItem('product-count') && JSON.parse(localStorage.getItem('product-count')).id === id) {
                setQuantity(JSON.parse(localStorage.getItem('product-count')).quantity);
                setChosenAddons(JSON.parse(localStorage.getItem('product-choseAddons'))?.chosenAddons);
                setPriceWithAddons(JSON.parse(localStorage.getItem('product-choseAddons'))?.priceWithAddons)
            } else {
                setChosenAddons(product?.productAddons);
            }
        }
        try {
            setPromotions(product?.promotions[0]);
        } catch (err) {
            console.log(err)
        }
    }, [product, promotions])

    useEffect(()=>{
        if (localStorage.getItem('chosen-cart-item')!==null && JSON.parse(localStorage.getItem('chosen-cart-item')).id===id){
            setCartItem(JSON.parse(localStorage.getItem('chosen-cart-item')));
        }else{
            dispatch(getProduct(id));
        }
        timings?.length<1 && dispatch(getStoreTiming());
        document.querySelector('.side-nav').scrollTo({ top: 0, behavior: 'auto' });
        window.scrollTo({ top: 0, behavior: 'auto' });
        return () => {
            dispatch(updateDataState({product: {}}));
            setCartItem({});
        }
    }, [])

    const handleChange = (e, addonId) => {
        let result;
        if (e.target.checked) {
            result = chosenAddons?.map(addon => {
                if (addon.id === addonId) {
                    if ('chosenModifiers' in addon) {
                        addon.chosenModifiers = [...addon.chosenModifiers, e.target.value]
                    } else {
                        addon.chosenModifiers = [e.target.value]
                    }
                    for (const modifier of addon?.modifiers) {
                        if (modifier?.id === e.target.value) {
                            setPriceWithAddons(prev => prev + modifier?.price)
                        }
                    }
                }
                return addon
            })
        } else {
            result = chosenAddons?.map(addon => {
                if (addon.id === addonId) {            
                    addon?.chosenModifiers?.splice(addon?.chosenModifiers?.indexOf(e.target.value), 1)
                    for (const modifier of addon?.modifiers) {
                        if (modifier?.id === e.target.value) {
                            setPriceWithAddons(prev => prev - modifier?.price)
                        }
                    }
                }
                return addon
            })
        }
        setChosenAddons(result);
    }
    
    function isAllRequiredSelected() {
        let result = true;
        if (chosenAddons?.length > 0) {
            for (const addon of chosenAddons) {
                if (addon?.required) {
                    if (addon?.chosenModifiers?.length >= addon?.minAllowed) {
                        result = true;
                    } else {
                        return false;
                    }
                } else {
                    result = true;
                }
            }
        }
        return result;
    }

    const addItemsToCart = () =>{
        if (!isAllRequiredSelected()){
            notification['warning']({
                message: 'Please provide all required information',
                placement: 'topLeft',
                className: 'selectAddonsNotification p-2',
                duration: 2,
            })
            return;
        }
        // if (localStorage.getItem('selected-mode') === null || localStorage.getItem('fulfillment-time')===null){
        //     localStorage.setItem('select-product-id', product.id);
        //     localStorage.setItem('product-choseAddons', JSON.stringify({chosenAddons, priceWithAddons}));
        //     localStorage.setItem('product-count', JSON.stringify({id, quantity}));
        //     history.push(APP_PREFIX_PATH+'/order-mode?mode=delivery');
        //     return;
        // }
        if (product?.stock > 0 && isAllRequiredSelected()) {
            if (cartItem?.product?.id){
                updateItemInCart(JSON.parse(localStorage.getItem('chosen-cart-item')), quantity, chosenAddons)
            }else{
                addToCart({ ...product, productAddons: chosenAddons, chosenAddons, priceWithAddons, comment }, quantity - getQuantity(product?.id))
            }
            localStorage.removeItem('chosen-cart-item')
            dispatch(changeQuantity(quantity - getQuantity(product?.id)));
            localStorage.removeItem('product-count');
            localStorage.removeItem('product-choseAddons');
            window.history.back()
        }
    }
    const minusItem = () => {
        if (quantity > 1) {
            setQuantity(quantity - 1)
        }
    }

    
    
    return (
        <div className={'singleProductPage'}>
            <div className='relative d-flex align-items-center'>
                <Button
                    className='products-back'
                    shape='circle'
                    onClick={() => window.history.back()}
                >
                    <ArrowLeftOutlined rotate={direction === DIR_RTL ? 180 : 0} />
                </Button>
            </div>
            <div className="productImgWrapper">
                {product?.label && <div className={`product-label ${locale !== 'en' && "labelAr"}`} style={{color: product?.label?.colorLight, backgroundColor: product?.label?.colorDark}}>
                    {locale === 'en' ? product?.label?.titleEng : product?.label?.titleAr}
                </div>}
                {product?.id ? (product?.images[0]?.id ? <ProductImg product={product}/> : <img src={"/img/productsFallback.svg"} className={'productsFallback'} alt={'Product'}/>) :
                    <Skeleton.Image active className='skeleton_for_image'/>}
            </div>
            <div className="bg-white p-3">
                <div className="pt-3">
                    <h2 className='productName text-black' style={{ fontSize: '32px', lineHeight: '100%', fontWeight: '600' }}>
                        {('nameEng' in product) ? (locale === 'en' ? (product?.nameEng) : product?.nameAr) : <SkeletonInput active style={{width: '300px'}} />}
                    </h2>
                    <div className='mb-2' style={{ color: '#616161' }}>
                        {('detailsEng' in product) ? (locale === 'en' ? (product?.detailsEng) : product?.detailsAr) : <Skeleton.Input style={{ width: '300px' }} active/>}
                    </div>
                    {!product?.stock > 0 ? <div className='soldOutTextSingle'>Sold out</div> :
                        <div className="text-black single_item_price">
                            { promotions?.discountType === 'AMOUNT' ? 
                                <span className='promotions'> {storeData?.currency?.name ?? "KWD"} {(promotions?.amount).toFixed(3)} discount</span>  : 
                              promotions?.discountType === 'PERCENTAGE' ? 
                                <span className='promotions'>{promotions?.amount}% off</span> : '' 
                            } <br/>
                            { storeData?.currency?.name ? storeData?.currency.name+" " : "KWD"} 
                            { product?.promotions?.length>0 ? 
                              <>
                                { promotions?.discountType === 'AMOUNT' ? 
                                    (product.price - promotions?.amount).toFixed(3) :
                                    promotions?.discountType === 'PERCENTAGE' ? 
                                    product.price - (product.price * (promotions.amount / 100)) : ""
                                }
                                <span style={{textDecoration:'line-through', marginLeft: '10px'}}>
                                    {storeData?.currency?.name ? storeData?.currency.name+" " : "KWD"}
                                    {product?.price}
                                </span>
                              </> : product?.price 
                            }
                        </div>}
                </div>
                <Divider className='my-3' />
                {
                    chosenAddons?.length>0 && chosenAddons?.map(addon => <div key={addon?.id}>
                        <div>
                            <div className='d-flex align-items-center justify-content-between'>
                                <div className='text-black font-bold' style={{ fontSize: '18px' }}>{locale === 'en' ? addon?.nameEng : addon?.nameAr}</div>
                                {addon?.required && <div>Required</div>}
                            </div>
                            <div className='mb-3'>Select {addon?.minAllowed}-{addon?.maxAllowed}</div>
                            {addon?.modifiers?.map(modifier => <div className='d-flex align-items-center mb-1' key={modifier?.id}>
                                <label htmlFor={modifier?.id} className="checkbox-container">
                                    <div>                      
                                        <Checkbox 
                                            id={modifier?.id} 
                                            checked={addon?.chosenModifiers?.includes(modifier?.id)} 
                                            value={modifier?.id} 
                                            onChange={e => handleChange(e, addon?.id)}
                                        />
                                        <span style={{ fontSize: '15px', marginLeft: '8px' }}>{locale === 'en' ? modifier?.nameEng : modifier?.nameAr}</span>
                                    </div>
                                    <div style={{fontSize: '15px'}}> {storeData?.currency?.name ? storeData?.currency.name : "KWD"} {modifier?.price?.toFixed(3)}</div>
                                </label>
                            </div>)}
                        </div>
                        <Divider className='my-3' />
                    </div>)
                }
                <div className='w-100' style={{ fontSize: "17px", color: '#000', fontWeight: '500' }}>
                    Special instructions
                </div>
                <Input
                    placeholder='Add Instructions'
                    prefix={<></>}
                    className='commentInput mt-2'
                    onChange={(e) => setComment(e.target.value)}
                />
            </div>
            <div className="singleItemFooter">
                <div className={`counterContainer my-0 ${!product?.stock > 0 && 'disabledCounterContainer'}`}>
                    <img
                        onClick={minusItem}
                        src='/img/minusItem.svg' alt='minus'
                        className={`${(quantity === 1 || !product?.stock > 0) && 'disabledSoldOutCounter'} changeQuantity`}
                    />
                    <div className={`mx-2 text-black font-16 ${!product?.stock > 0 && 'disabledSoldOutCounter'}`}>{quantity}</div>
                    <img onClick={() => (product?.stock > 0 && quantity < product?.stock) && setQuantity(quantity + 1)} src='/img/plusItem.svg' alt='plus' className={`${(!product?.stock > 0 || quantity === product?.stock) && 'disabledSoldOutCounter'} changeQuantity`} />
                </div>
                <Button className={`w-100 primaryColor mt-3 ${ !isAllRequiredSelected() ? 'disabledItemButton' : 'activeButton'}`} onClick={addItemsToCart} disabled={!product?.stock > 0 || !storeData?.enableDelivery}>
                    {(storeData?.enableDelivery && isOpenByTime(timings)) ? <div className={`w-100 d-flex justify-content-${product?.stock > 0 ? 'between' : 'center'}`}>
                        {isItemExistsInCart(product?.id, ('chosenAddons' in product ? product?.chosenAddons : product?.productAddons)) 
                        ? <span>Update Item</span> : <span>Add To Cart</span>}
                        
                        {product?.stock > 0 && <span> {storeData?.currency?.name ? storeData?.currency.name : "KWD"} {(priceWithAddons * quantity).toFixed(3)} <br/> 
                        </span>}
                    </div> : <div>
                        Sorry! we're temporarily closed
                    </div>}
                </Button>
            </div>
        </div>
    )
}

export default SingleProduct